import React from 'react'
import { useState, useEffect, useContext } from 'react'
import apiClient from '../../helpers/axiosHelper'
import './biblioteca.css'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../context/Authcontext'
import { useToggle } from '../../context/toggle/toggleBtn'
import { LoadingComponent } from '../common/LoadingComponent/LoadingComponent'


export const Biblioteca = () => {

  const { toggleClose } = useToggle()

  useEffect(() => {
    document.title = 'TPA® Oficial - Bibliotecas'
    toggleClose()
  }, [])


  const [libreryData, setLibreryData] = useState(null)
  const [loading, setLoading] = useState(true)
  const { logout } = useContext(AuthContext)


  useEffect(() => {
    const fetchLibrery = async () => {
      try {

        const response = await apiClient.get('Library/GetLibraries')

        //console.log('response.Library: ', response)
        if (response) {
          setLibreryData(response.data)

          setLoading(false)

        }
      } catch (error) {
        // logout()
        //console.log('error capturado en la biblioteca: ',error)
        setLoading(false)
      }
    }

    fetchLibrery()
  }, [logout])

  // if (loading) {
  //   return  <LoadingComponent/>
  // }

  return (

    <>

      {loading ?
        <LoadingComponent />
        :
        <div className="main-container">

          <div className={`box-container ${loading && 'waiting-data'}`}>

            {/* {loading && <LoadingComponent/>} */}
            {libreryData && libreryData.length > 0 ? libreryData.map((l) => (


              <Link key={l.id} to={`/videos/${l.externalReference}`} >

                <div className="box">
                  <div className="img-container">
                    <img src={l.pictureUrl}
                      alt={l.name} />
                  </div>
                  <div className="description">
                    <div className="h3-container">
                      <i className="bi bi-collection-fill bi-class-colecction"><h3>{l.name}</h3></i>
                    </div>

                    {/* <div className="p-container">
             <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Deserunt, labore a debitis
               qui, iusto expedita ab aperiam officia dicta in consectetur voluptates veritatis est
               rerum ducimus aliquid dolorum quasi, beatae iure quas doloribus molestias incidunt
               praesentium! Eligendi harum repellat, odit delectus dolores repellendus eaque,
               distinctio consectetur, exercitationem pariatur quibusdam nesciunt.</p>
           </div> */}
                  </div>

                </div>
              </Link>

            ))
              :
              null
            }

          </div>
        </div>


      }

    </>


  )
}
